import { lighten, darken } from '@mui/material/styles';

export const colorGenerator = (() => {
    let lastHueBand = null;

    const hueBands = [
        { name: 'red', range: [0, 20] },
        { name: 'orange', range: [21, 50] },
        { name: 'yellow', range: [51, 70] },
        { name: 'green', range: [71, 150] },
        { name: 'cyan', range: [151, 200] },
        { name: 'blue', range: [201, 260] },
        { name: 'purple', range: [261, 290] },
        { name: 'pink', range: [291, 330] },
    ];

    const getRandomPastel = (h, s = 70, l = 85) => {
        return `hsl(${h}, ${s}%, ${l}%)`;
    };

    return (darkness = 85) => {
        const availableBands = hueBands.filter(b => b.name !== lastHueBand);
        const band = availableBands[Math.floor(Math.random() * availableBands.length)];
        lastHueBand = band.name;

        const hue = Math.floor(Math.random() * (band.range[1] - band.range[0] + 1)) + band.range[0];
        return getRandomPastel(hue, 70, darkness);
    };
})();


export const getPastelColorByBand = (colorOrHex, darkness = 85) => {
    const hueBands = [
        { name: 'red', range: [0, 20] },
        { name: 'orange', range: [21, 50] },
        { name: 'yellow', range: [51, 70] },
        { name: 'green', range: [71, 150] },
        { name: 'cyan', range: [151, 200] },
        { name: 'blue', range: [201, 260] },
        { name: 'purple', range: [261, 290] },
        { name: 'pink', range: [291, 330] },
    ];

    const getPastel = (h, s = 70, l = 85) => `hsl(${h}, ${s}%, ${l}%)`;

    if (typeof colorOrHex === 'string' && colorOrHex.startsWith('#')) {
        const { h } = hexToHsl(colorOrHex);
        return getPastel(h, 70, darkness);
    }

    const band = hueBands.find(b => b.name === colorOrHex);
    if (band) {
        const midHue = Math.floor((band.range[0] + band.range[1]) / 2);
        return getPastel(midHue, 70, darkness);
    }

    return '#cccccc'; // fallback
};

const hexToHsl = (hex) => {
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('');
    }

    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    const rNorm = r / 255, gNorm = g / 255, bNorm = b / 255;
    const max = Math.max(rNorm, gNorm, bNorm), min = Math.min(rNorm, gNorm, bNorm);
    let h = 0, s = 0, l = (max + min) / 2;

    if (max !== min) {
        const d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case rNorm: h = (gNorm - bNorm) / d + (gNorm < bNorm ? 6 : 0); break;
            case gNorm: h = (bNorm - rNorm) / d + 2; break;
            case bNorm: h = (rNorm - gNorm) / d + 4; break;
        }
        h = Math.round(h * 60);
    }

    return { h, s: Math.round(s * 100), l: Math.round(l * 100) };
};

export const getStatusColor = (theme, colorName, level = 0, effect = 'lighten') => {

    if (!colorName || !theme.palette[colorName]) {
        return 'transparent';
    }

    const baseColor = theme.palette[colorName].main;

    if (level === 0) {
        return baseColor;
    }

    if (effect === 'lighten') {
        return lighten(baseColor, level);
    } else {
        return darken(baseColor, level);
    }
};

